import { List, Map, Record } from 'immutable';
export var Links = Record({
  Home: 'https://via.placeholder.com/600x200?text=Missing%20home%20link',
  availableBalanceMeaning: '',
  support: 'https://via.placeholder.com/600x200?text=Missing%20support%20link',
  reportFraud: 'https://via.placeholder.com/600x200?text=Missing%20report%20fraud%20link',
  contactLink: 'https://via.placeholder.com/600x200?text=Missing%20contact%20link',
  faqLink: 'https://via.placeholder.com/600x200?text=Missing%20faq%20link',
  cardReaderHelpLink: 'https://via.placeholder.com/600x200?text=Missing%20card%20reader%20help%20link',
  soBanklineNotSupported: 'https://via.placeholder.com/600x200?text=So%20not%20supported',
  forgottenYourDetails: 'https://via.placeholder.com/600x200?text=Forgotten%20your%20details',
  cookieBannerLink: 'https://via.placeholder.com/600x200?text=Cookie%20banner%20link',
  internationalPaymentTermsAndConditions: 'https://via.placeholder.com/600x200?text=Missing%20international%20payment%20terms%20and%20conditions%20link',
  internationalPaymentTypeDefinitions: null,
  noAccountsFaq: null,
  accountDisabledLink: 'https://via.placeholder.com/600x200?text=Missing%20account%20disabled%20link',
  orderCardReaderLink: 'https://via.placeholder.com/600x200?text=Missing%20order%20card%20reader%20link',
  accountSecurityLink: 'https://via.placeholder.com/600x200?text=Missing%20fraud%20and%20security%20link',
  reregisterLink: 'https://via.placeholder.com/600x200?text=Reregister%20link'
});
export var Brand = Record({
  id: 'BRAND ID MISSING',
  name: 'BRAND NAME IS MISSING',
  brandLogo: 'BRAND LOGO is missing',
  serviceName: 'BRAND SERVICE NAME IS MISSING',
  links: new Links({}),
  footer: Map(),
  copyright: "BRAND COPYRIGHT IS MISSING",
  avatarColours: List(),
  home: 'BRAND HOME IS MISSING',
  helpNowBrand: 'BRAND FOR HELP NOW IS MISSING',
  showTimeInUKNotice: true,
  paymentLabelChaps: 'CHAPS Payment',
  paymentLabelSingleImmediate: 'Single immediate payment',
  paymentLabelScheduled: 'Future dated faster payment',
  accountNumberFormat: 'bban',
  permissionsDisclaimer: null,
  jurisdictionDisclaimer: null,
  loginLink: null,
  displayBalancesUpdatedDate: true,
  copy: Map(),
  ssoEnabled: false,
  showMortgageConsents: false
});
export var isLegacyTheme = function isLegacyTheme(brandId) {
  return brandId === 'iom';
};